import { Link, useStaticQuery, graphql } from "gatsby"
import React, { useState, useEffect } from "react"
import WhitelogoImg from "../images/logo-white.svg"
import LogoImg from "../images/logo.svg"
import LinkButton from "../components/link-button"
import "./header.css"

function Header({ isRootPath }) {
  const [isExpanded, toggleExpansion] = useState(false)
  const [isProductExpanded, toggleProductExpansion] = useState(false)
  const [isDownloadExpanded, toggleDownloadExpansion] = useState(false)
  const [onTop, setOnTop] = useState(true)
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)

  function onScroll() {
    const offset =
      window.pageYOffset ||
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop

    if (offset >= 100 && !onTop) return false
    if (offset >= 100 && onTop) {
      setOnTop(false)
      return false
    }
    setOnTop(true)
  }

  useEffect(() => {
    document.addEventListener("scroll", onScroll)
    return () => document.removeEventListener("scroll", onScroll)
  })

  return (
    <nav
      className={`${
        !onTop | isExpanded && "bg-white shadow-lg"
      } ${onTop ? "fixed mt-8" : "sticky"} top-0 w-full z-50 px-4 py-2 lg:p-5 mb-6`}
    >
      <div className="flex flex-wrap items-center justify-between">
        <div className={`flex items-center flex-shrink-0 mr-7`}>
          <Link to={`/`} className="hover:opacity-80">
            <img
              className={`
                ${isRootPath && onTop && !isExpanded ? "block" : "hidden"}
                 w-40 lg:w-auto
              `}
              src={WhitelogoImg}
              alt={data.site.siteMetadata.title}
            />
            <img
              className={`
                ${isRootPath && onTop && !isExpanded ? "hidden" : "block"}
                 w-40 lg:w-auto
              `}
              src={LogoImg}
              alt={data.site.siteMetadata.title}
            />
          </Link>
        </div>
        <div className="block lg:hidden -mr-3">
          <button
            onClick={() => {
              toggleExpansion(!isExpanded)
              toggleProductExpansion(false)
            }}
            className={`flex items-center px-3 py-2  ${
              isRootPath && onTop && !isExpanded
                ? "text-white"
                : "text-blue-950"
            } ${isExpanded && `rotate-180`}`}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.293 7.293L9.99997 11.586L5.70697 7.293L4.29297 8.707L9.99997 14.414L15.707 8.707L14.293 7.293Z"
                fill={isRootPath && onTop && !isExpanded ? "white" : "#0A293B"}
              />
            </svg>
          </button>
        </div>
        <div
          className={`${
            isExpanded ? `block` : `hidden`
          } w-full block lg:flex lg:items-center lg:w-auto mb-1 py-4 lg:py-0`}
        >
          <div
            className={`text-sm lg:flex-grow lg:flex lg:flex-gap-6 lg:items-stretch ${
              isRootPath && onTop && !isExpanded
                ? "text-white"
                : "text-blue-950"
            }`}
          >
            <Link to={`/about-cdp/`} className="block py-2 text-xs text-center lg:flex lg:items-center hover:opacity-80 lg:py-0 font-medium">
              CDPの基礎知識
            </Link>
            <div className={`product lg:flex lg:items-center relative`}>
              <button
                className={`flex py-2 text-xs items-center justify-center lg:justify-items-start gap-2 lg:py-0 font-medium hover:opacity-80 w-full lg:w-auto`}
                onClick={() => toggleProductExpansion(!isProductExpanded)}
              >
                製品
                <div className={`${isProductExpanded && `rotate-180`}`}>
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.14601 3.64511L4.99951 5.79161L2.85301 3.64511L2.14601 4.35211L4.99951 7.20561L7.85301 4.35211L7.14601 3.64511Z"
                      fill={
                        isRootPath && onTop && !isExpanded ? "white" : "#0A293B"
                      }
                    />
                  </svg>
                </div>
              </button>
              {/* PC専用メニュー（LG以上のみ表示） */}
              <div
                className={`product-menu ${
                  isProductExpanded ? `block` : `hidden`
                }`}
              >
                <div className="hidden md:block">
                  <p>INTEGRAL-CORE</p>
                  <p>データのサイロ化を解決し、個人情報も含めた適切な顧客データ活用をサポートするデータ基盤・CDP</p>
                  <Link to={`/function/`}>
                  <svg width="24" height="26" viewBox="0 0 24 24" fill="#0A293B" xmlns="http://www.w3.org/2000/svg" class="fill-link-blue">
                    <path fill="#0A293B" d="M8.76768 6.78615C8.59628 6.96943 8.5 7.21797 8.5 7.47712C8.5 7.73628 8.59628 7.98482 8.76768 8.1681L13.2932 13.0059L8.76768 17.8437C8.60114 18.028 8.50899 18.2749 8.51107 18.5312C8.51316 18.7874 8.60931 19.0325 8.77882 19.2137C8.94832 19.395 9.17763 19.4977 9.41734 19.5C9.65705 19.5022 9.888 19.4037 10.0604 19.2257L15.2323 13.6969C15.4037 13.5136 15.5 13.2651 15.5 13.0059C15.5 12.7467 15.4037 12.4982 15.2323 12.3149L10.0604 6.78615C9.88898 6.60293 9.65648 6.5 9.41405 6.5C9.17163 6.5 8.93913 6.60293 8.76768 6.78615Z"></path>
                  </svg>
                    機能
                  </Link>
                  <Link to={`/tools/`}>
                  <svg width="24" height="26" viewBox="0 0 24 24" fill="#0A293B" xmlns="http://www.w3.org/2000/svg" class="fill-link-blue">
                    <path fill="#0A293B" d="M8.76768 6.78615C8.59628 6.96943 8.5 7.21797 8.5 7.47712C8.5 7.73628 8.59628 7.98482 8.76768 8.1681L13.2932 13.0059L8.76768 17.8437C8.60114 18.028 8.50899 18.2749 8.51107 18.5312C8.51316 18.7874 8.60931 19.0325 8.77882 19.2137C8.94832 19.395 9.17763 19.4977 9.41734 19.5C9.65705 19.5022 9.888 19.4037 10.0604 19.2257L15.2323 13.6969C15.4037 13.5136 15.5 13.2651 15.5 13.0059C15.5 12.7467 15.4037 12.4982 15.2323 12.3149L10.0604 6.78615C9.88898 6.60293 9.65648 6.5 9.41405 6.5C9.17163 6.5 8.93913 6.60293 8.76768 6.78615Z"></path>
                  </svg>
                    連携ツール
                  </Link>
                  <Link to={`/security/`}>
                  <svg width="24" height="26" viewBox="0 0 24 24" fill="#0A293B" xmlns="http://www.w3.org/2000/svg" class="fill-link-blue">
                    <path fill="#0A293B" d="M8.76768 6.78615C8.59628 6.96943 8.5 7.21797 8.5 7.47712C8.5 7.73628 8.59628 7.98482 8.76768 8.1681L13.2932 13.0059L8.76768 17.8437C8.60114 18.028 8.50899 18.2749 8.51107 18.5312C8.51316 18.7874 8.60931 19.0325 8.77882 19.2137C8.94832 19.395 9.17763 19.4977 9.41734 19.5C9.65705 19.5022 9.888 19.4037 10.0604 19.2257L15.2323 13.6969C15.4037 13.5136 15.5 13.2651 15.5 13.0059C15.5 12.7467 15.4037 12.4982 15.2323 12.3149L10.0604 6.78615C9.88898 6.60293 9.65648 6.5 9.41405 6.5C9.17163 6.5 8.93913 6.60293 8.76768 6.78615Z"></path>
                  </svg>
                    セキュリティ
                  </Link>
                </div>
                <div className="hidden md:block tool-columns-wrapper">
                  <div className="tool-columns">
                    <div className="tool-block">
                      <Link to={`/bridgesignal/`} className="product-menu-item">
                        <svg width="24" height="26" viewBox="0 0 24 24" fill="#0A293B" xmlns="http://www.w3.org/2000/svg" class="fill-link-blue">
                          <path fill="#0A293B" d="M8.76768 6.78615C8.59628 6.96943 8.5 7.21797 8.5 7.47712C8.5 7.73628 8.59628 7.98482 8.76768 8.1681L13.2932 13.0059L8.76768 17.8437C8.60114 18.028 8.50899 18.2749 8.51107 18.5312C8.51316 18.7874 8.60931 19.0325 8.77882 19.2137C8.94832 19.395 9.17763 19.4977 9.41734 19.5C9.65705 19.5022 9.888 19.4037 10.0604 19.2257L15.2323 13.6969C15.4037 13.5136 15.5 13.2651 15.5 13.0059C15.5 12.7467 15.4037 12.4982 15.2323 12.3149L10.0604 6.78615C9.88898 6.60293 9.65648 6.5 9.41405 6.5C9.17163 6.5 8.93913 6.60293 8.76768 6.78615Z"></path>
                        </svg>
                        INTEGRAL-CORE BridgeSignal
                      </Link>
                      <p>webサイトにタグを設置するだけで、同一人物の行動を複数のデバイスやドメインにまたがって1つに繋げられるIDを生成・管理するツール</p>
                    </div>
                    <div className="tool-block">
                      <Link to={`/jetjunction-ga4/`} className="product-menu-item">
                        <svg width="24" height="26" viewBox="0 0 24 24" fill="#0A293B" xmlns="http://www.w3.org/2000/svg" class="fill-link-blue">
                          <path fill="#0A293B" d="M8.76768 6.78615C8.59628 6.96943 8.5 7.21797 8.5 7.47712C8.5 7.73628 8.59628 7.98482 8.76768 8.1681L13.2932 13.0059L8.76768 17.8437C8.60114 18.028 8.50899 18.2749 8.51107 18.5312C8.51316 18.7874 8.60931 19.0325 8.77882 19.2137C8.94832 19.395 9.17763 19.4977 9.41734 19.5C9.65705 19.5022 9.888 19.4037 10.0604 19.2257L15.2323 13.6969C15.4037 13.5136 15.5 13.2651 15.5 13.0059C15.5 12.7467 15.4037 12.4982 15.2323 12.3149L10.0604 6.78615C9.88898 6.60293 9.65648 6.5 9.41405 6.5C9.17163 6.5 8.93913 6.60293 8.76768 6.78615Z"></path>
                        </svg>
                        INTEGRAL-CORE JetJunction
                      </Link>
                      <p>Google Analytics Data APIおよびBigQueryのデータ加工作業やリクエスト制限をなくし、GA4のデータを簡単に抽出・集計できるツール</p>
                    </div>
                  </div>
                </div>
                {/* モバイル専用メニュー（LG未満のみ表示） */}
                <div className="product-menu-mobile md:hidden">
                  <Link to="/function/" className="mobile-menu-item">機能</Link>
                  <Link to="/tools/" className="mobile-menu-item">連携ツール</Link>
                  <Link to="/security/" className="mobile-menu-item">セキュリティ</Link>
                  <Link to="/bridgesignal/" className="mobile-menu-item">BridgeSignal</Link>
                  <Link to="/jetjunction-ga4/" className="mobile-menu-item">JetJunction</Link>
                </div>
              </div>
            </div>
            <Link to={`/support/`} className="block py-2 text-xs text-center lg:flex lg:items-center hover:opacity-80 lg:py-0 font-medium">
              サポート
            </Link>
            <a
              href="https://www.ever-rise.co.jp/dx-blog/cases-integral-core/"
              className="block py-2 text-xs text-center lg:flex lg:items-center hover:opacity-80 lg:py-0 font-medium"
              target="_blank"
            >
              導入企業
            </a>
            <Link to={`/seminar/?filter=accepting`} className="block py-2 text-xs text-center lg:flex lg:items-center hover:opacity-80 lg:py-0 font-medium">
              セミナー・動画
            </Link>
            <Link to={`/resource/`} className="block py-2 text-xs text-center lg:flex lg:items-center hover:opacity-80 lg:py-0 font-medium">
              資料
            </Link>
            <a
              href="https://www.ever-rise.co.jp/dx-blog/tag/cdp/"
              className="block py-2 text-xs text-center lg:flex lg:items-center hover:opacity-80 lg:py-0 font-medium"
              target="_blank"
            >
              ブログ
            </a>
            <Link to={`/demo-request/`} className="block py-2 text-xs text-center lg:flex lg:items-center hover:opacity-80 lg:py-0 font-medium">
              デモリクエスト
            </Link>
            <div className="text-sm pt-3 lg:pt-0">
              <div className=" lg:flex-grow flex flex-gap-2 items-center justify-center">
                <div
                  className="download lg:flex lg:items-center relative"
                  onMouseEnter={() => toggleDownloadExpansion(true)}
                  onMouseLeave={() => toggleDownloadExpansion(false)}
                >
               <LinkButton
                text="製品資料ダウンロード"
                url="/resource/integral-core/"
                type="secondary"
                size="s"
              />
                  <div className={`download-menu ${isDownloadExpanded ? "block" : "hidden"}`}>
                    <Link to="/resource/integral-core/" className="download-menu-item">
                      INTEGRAL-CORE
                    </Link>
                    <Link to="/resource/bridgesignal/" className="download-menu-item">
                      BridgeSignal
                    </Link>
                    <Link to="/resource/jetjunction/" className="download-menu-item">
                      JetJunction
                    </Link>

                  </div>
                </div>
              <LinkButton
                text="導入相談"
                url="/contact/"
                type="primary"
                size="s"
              />
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Header
